module.exports = __webpack_public_path__ + "img/zh_xi.be7eb430.png";